"use client";
import useNativeAppSetup from "@/lib/hooks/use-native-app-setup";

export const NativeAppConnector = () => {
  useNativeAppSetup();
  return null;
};
